import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MobileLoginPage from './components/MobileLoginPage';
import AuthenticatedApp from './AuthenticatedApp';

export function AppRouter() {
  return (
    <Routes>
      {/* Rotta per login mobile QR */}
      <Route path="/mobile-login/:sessionId" element={<MobileLoginPage />} />
      
      {/* Rotta principale per l'app */}
      <Route path="/*" element={<AuthenticatedApp />} />
    </Routes>
  );
}

export default AppRouter;
